import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { IDENTITIES_PATH } from './constants';
import { BackButton, BackButtonWrap } from './styles';

export function BackToIdentities() {
  const navigate = useNavigate();

  return (
    <BackButtonWrap>
      <BackButton
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(IDENTITIES_PATH)}
      >
        BACK TO IDENTITIES
      </BackButton>
    </BackButtonWrap>
  );
}
